export default __webpack_public_path__ + "static/media/add-note.1888b6b4.png";